import React from 'react'

import { Col } from '../../../../../../packages/kiti/components/structure/Grid'
import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../../EditableSentence'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import Modal from '../../../../../../components/structure/Modal'
import Separator from '../../../../../../packages/kiti/components/helpers/Separator'
import SubmitBar from '../../../../../../packages/kiti/components/form/SubmitBar'
import Text from '../../../../../../packages/kiti/components/presentation/Text'
import Textarea from '../../../../../../components/form/Textarea'
import TemplateSelect from '../../../../../../containers/integrations/Twilio/TemplateSelect'
import extractVariables from './_helpers/extractVariables'
import { useIntegration } from '../../../_load/IntegrationLoader'
import validate from './_helpers/validate'
const TwilioSendWhatAppSentence = () => {
  const [open, setOpen] = React.useState()
  const { form, setErrors } = useFormState()

  const body = form?.payload?.template?.types?.twilioText?.body
  const variables = extractVariables(body)

  const integration = useIntegration()

  const handleSubmit = () => {
    const isValid = validate(form, variables, setErrors)
    if (isValid) setOpen(false)
  }

  return (
    <>
      <Text size="h2">do telefone</Text>

      <EditableSentence
        label={form.payload?.from || '_______'}
        truncate={20}
        onClick={() => setOpen(true)}
        field="payload"
      />

      {/*TODO: Select for twilio number*/}

      <Modal open={open} onClose={() => setOpen(false)} width="32rem">
        <Col width="100%">
          <FormItem
            label="Template*"
            path={['payload', 'template']}
            Input={props => <TemplateSelect filter={{ integrationId: integration.id }} {...props} />}
          />
        </Col>

        <Separator weight={4} />

        <Col width="100%">
          <FormItem
            label="Meu telefone twilio*"
            path={['payload', 'from']}
            value={integration?.extraData?.myTwilioPhone}
          />
        </Col>

        <Separator weight={4} />

        <Col width="100%">
          <FormItem label="Para*" path={['payload', 'to']} />
        </Col>

        <Separator weight={4} />

        <Col width="100%">
          <FormItem label="Mensagem*" path={['payload', 'body']} Input={Textarea} disabled={true} value={body} />
        </Col>

        {variables &&
          variables.map((variable, index) => {
            return (
              <Col width="100%" key={index}>
                <Separator weight={4} />
                <FormItem label={`{{${variable}}}*`} path={['payload', 'template', 'contentVariables', variable]} />
              </Col>
            )
          })}

        <SubmitBar onClick={handleSubmit} />
      </Modal>
    </>
  )
}

export default TwilioSendWhatAppSentence
